<div class="title">
  <img
    [src]="src"
    alt="Reviews"
    class="title__img"
    [ngClass]="['title__img_' + type]"
  >
  <p class="title__txt"><ng-content></ng-content></p>
</div>
